"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var x_data_grid_pro_1 = require("@mui/x-data-grid-pro");
var material_1 = require("@mui/material");
var react_1 = require("react");
var x_license_pro_1 = require("@mui/x-license-pro");
var react_i18next_1 = require("react-i18next");
var SearchBar_1 = __importDefault(require("../SearchBar"));
x_license_pro_1.LicenseInfo.setLicenseKey('b0d7224f10868840570e4ea1942f3eefTz0xMDMzNzgsRT0xNzY0NzgyMTUwMDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI=');
var removeDiacritics = function (str) {
    return str
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase();
};
function CustomToolbar(_a) {
    var searchBar = _a.searchBar, id = _a.id, onSearchValueChange = _a.onSearchValueChange, searchBarAdvancedSettings = _a.searchBarAdvancedSettings, searchValue = _a.searchValue, exportTool = _a.exportTool;
    var _b = __read((0, react_1.useState)(false), 2), showFilters = _b[0], setShowFilters = _b[1];
    if (searchBar) {
        return ((0, jsx_runtime_1.jsx)(x_data_grid_pro_1.GridToolbarContainer, __assign({ sx: { mt: '-70px', pb: showFilters ? 0 : 2 } }, { children: (0, jsx_runtime_1.jsxs)(material_1.Stack, __assign({ direction: "column", sx: { width: '100%' } }, { children: [(0, jsx_runtime_1.jsx)(material_1.Stack, __assign({ sx: {
                            direction: 'row',
                            justifyContent: 'flex-end',
                        } }, { children: (0, jsx_runtime_1.jsx)(material_1.Stack, __assign({ direction: "row", alignItems: "center", justifyContent: "flex-end" }, { children: (0, jsx_runtime_1.jsx)(SearchBar_1.default, { id: "searchTable".concat(id), onChange: onSearchValueChange, advancedSettings: searchBarAdvancedSettings, onClickAdvancedSettings: function () { return setShowFilters(!showFilters); }, advancedSelected: showFilters, value: searchValue }) })) })), searchBarAdvancedSettings && ((0, jsx_runtime_1.jsx)(material_1.Collapse, __assign({ in: showFilters }, { children: (0, jsx_runtime_1.jsxs)(material_1.Stack, __assign({ sx: { p: 4, minWidth: '100%', alignItems: 'flex-start' } }, { children: [(0, jsx_runtime_1.jsx)(x_data_grid_pro_1.GridFilterPanel, {}), exportTool && (0, jsx_runtime_1.jsx)(x_data_grid_pro_1.GridToolbarExport, { sx: { pl: 1.5 } })] })) })))] })) })));
    }
    return null;
}
function BravasTable(_a) {
    var columns = _a.columns, rows = _a.rows, getRowId = _a.getRowId, actionButtons = _a.actionButtons, onRowClick = _a.onRowClick, handleRowSelection = _a.handleRowSelection, height = _a.height, id = _a.id, searchBarAdvancedSettings = _a.searchBarAdvancedSettings, showActionButtons = _a.showActionButtons, searchBar = _a.searchBar, rowHeight = _a.rowHeight, dashedIds = _a.dashedIds, handleSelectedRows = _a.handleSelectedRows, idField = _a.idField, hideCheckBox = _a.hideCheckBox, isRowSelectable = _a.isRowSelectable, hideList = _a.hideList, exportTool = _a.exportTool, defaultSortingField = _a.defaultSortingField;
    var _b = __read((0, react_1.useState)([]), 2), selectedRows = _b[0], setSelectedRows = _b[1];
    var _c = __read((0, react_1.useState)({
        items: [],
        logicOperator: x_data_grid_pro_1.GridLogicOperator.Or,
        quickFilterValues: [],
    }), 2), filterModel = _c[0], setFilterModel = _c[1];
    var _d = __read((0, react_1.useState)(''), 2), rawFilterValue = _d[0], setRawFilterValue = _d[1];
    var onSearchValueChange = function (event) {
        var newFilterModel = {
            items: filterModel.items,
            logicOperator: x_data_grid_pro_1.GridLogicOperator.Or,
            quickFilterValues: event.target.value.split(' '),
        };
        setFilterModel(newFilterModel);
        setRawFilterValue(event.target.value);
    };
    var t = (0, react_i18next_1.useTranslation)().t;
    return ((0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ sx: { flexGrow: 2, pt: -1 } }, { children: [(0, jsx_runtime_1.jsx)(material_1.Stack, __assign({ justifyContent: "flex-start", direction: "row", alignItems: "center", height: (searchBar || actionButtons.length > 0) && showActionButtons
                    ? '40px'
                    : '0px', spacing: 2 }, { children: showActionButtons &&
                    (actionButtons === null || actionButtons === void 0 ? void 0 : actionButtons.map(function (button) {
                        return ((0, jsx_runtime_1.jsx)(material_1.Collapse, __assign({ in: !button.disabled, orientation: "vertical" }, { children: (0, jsx_runtime_1.jsx)(material_1.Button, __assign({ style: { zIndex: 2 }, variant: button.primary ? 'contained' : 'outlined', disabled: button.disabled, color: button.primary ? 'primary' : 'darkGrey', onClick: function () {
                                    if (button.onClick) {
                                        button.onClick(selectedRows);
                                    }
                                }, startIcon: button.icon }, { children: button.libelle }), button.libelle) })));
                    })) })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ sx: {
                    mt: 3,
                    height: rows.length > 0 ? height : '120px',
                    width: '100%',
                    borderRadius: '10px 10px 10px 10px',
                    borderColor: 'secondary.light',
                    borderStyle: 'solid',
                    borderWidth: '1px',
                    padding: '0px 0px 0px 0px',
                    boxShadow: 'inset 0px -15px 10px -15px #CCC',
                    '& .unknown': {
                        color: 'gray',
                    },
                } }, { children: (0, jsx_runtime_1.jsx)(x_data_grid_pro_1.DataGridPro, { initialState: {
                        sorting: {
                            sortModel: [
                                { field: defaultSortingField || columns[0].field, sort: 'asc' },
                            ],
                        },
                    }, isRowSelectable: isRowSelectable, localeText: {
                        noRowsLabel: t('ds.norows'),
                        filterOperatorContains: t('ds.filterOperatorContains'),
                        filterOperatorEquals: t('ds.filterOperatorEquals'),
                        filterOperatorStartsWith: t('ds.filterOperatorStartsWith'),
                        filterOperatorEndsWith: t('ds.filterOperatorEndsWith'),
                        filterOperatorIs: t('ds.filterOperatorIs'),
                        filterOperatorNot: t('ds.filterOperatorNot'),
                        filterOperatorIsEmpty: t('ds.filterOperatorIsEmpty'),
                        filterOperatorIsNotEmpty: t('ds.filterOperatorIsNotEmpty'),
                        filterPanelAddFilter: t('ds.filterPanelAddFilter'),
                        filterPanelRemoveAll: t('ds.filterPanelRemoveAll'),
                        filterPanelDeleteIconLabel: t('ds.filterPanelDeleteIconLabel'),
                        filterPanelLogicOperator: t('ds.filterPanelLogicOperator'),
                        filterPanelOperator: t('ds.filterPanelOperator'),
                        filterPanelOperatorAnd: t('ds.filterPanelOperatorAnd'),
                        filterPanelOperatorOr: t('ds.filterPanelOperatorOr'),
                        filterPanelColumns: t('ds.filterPanelColumns'),
                        filterPanelInputLabel: t('ds.filterPanelInputLabel'),
                        filterPanelInputPlaceholder: t('ds.filterPanelInputPlaceholder'),
                        toolbarFilters: t('ds.toolbarFilters'),
                        toolbarFiltersLabel: t('ds.toolbarFiltersLabel'),
                        filterOperatorIsAnyOf: t('ds.filterOperatorIsAnyOf'),
                        toolbarExport: t('ds.toolbarExport'),
                        toolbarExportLabel: t('ds.toolbarExportLabel'),
                        toolbarExportCSV: t('ds.toolbarExportCSV'),
                        toolbarExportPrint: t('ds.toolbarExportPrint'),
                        toolbarExportExcel: t('ds.toolbarExportExcel'),
                    }, slots: {
                        toolbar: CustomToolbar,
                    }, slotProps: {
                        toolbar: {
                            searchBar: searchBar,
                            id: id,
                            onSearchValueChange: onSearchValueChange,
                            searchBarAdvancedSettings: searchBarAdvancedSettings,
                            searchValue: rawFilterValue,
                            exportTool: exportTool,
                        },
                    }, onFilterModelChange: function (model) {
                        var newFilter = __assign(__assign({}, model), { quickFilterValues: filterModel.quickFilterValues });
                        setFilterModel(newFilter);
                    }, getRowId: function (row) {
                        return getRowId(row);
                    }, rowHeight: rowHeight, rows: rows, filterModel: filterModel, columns: __spreadArray([], __read(columns.map(function (col) {
                        if (!col.field || col.filterable === false)
                            return col;
                        return __assign(__assign({}, col), { getApplyQuickFilterFn: function (filterValue) {
                                if (!filterValue)
                                    return null;
                                var normalizedFilter = removeDiacritics(filterValue);
                                return function (cell) {
                                    if (cell == null)
                                        return false;
                                    var normalizedValue = removeDiacritics(String(cell.value));
                                    return normalizedValue.includes(normalizedFilter);
                                };
                            } });
                    })), false), checkboxSelection: showActionButtons && !hideCheckBox, disableRowSelectionOnClick: true, disableColumnMenu: true, disableColumnSelector: true, hideFooter: true, hideFooterSelectedRowCount: true, columnVisibilityModel: hideList, rowSelectionModel: handleSelectedRows || selectedRows, onRowSelectionModelChange: function (itm) {
                        setSelectedRows(itm);
                        if (handleRowSelection) {
                            handleRowSelection(itm);
                        }
                    }, getCellClassName: function (
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    params) {
                        if (params.value === null || params.value === undefined) {
                            return 'unknown';
                        }
                        return '';
                    }, onRowClick: function (params) {
                        if (onRowClick) {
                            onRowClick(params.row);
                        }
                    }, 
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    getRowClassName: function (params) {
                        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                        return (dashedIds === null || dashedIds === void 0 ? void 0 : dashedIds.includes(params.row[idField || 'id']))
                            ? 'bravasDashed'
                            : 'bravasNormal';
                    }, sx: {
                        borderWidth: 0,
                        borderRadius: '10px 10px 10px 10px',
                        '& .MuiDataGrid-main': {
                            borderRadius: '10px 10px 10px 10px',
                        },
                        '& .MuiDataGrid-virtualScrollerRenderZone': {
                            '& .MuiDataGrid-cell': {
                                borderBottom: 0,
                            },
                        },
                        '& .MuiDataGrid-columnHeaders': {
                            color: 'text.primary',
                            fontSize: 14,
                            borderBottom: 1,
                            borderColor: 'secondary.light',
                        },
                        '& .MuiDataGrid-columnHeaderTitle': {
                            fontWeight: 'bold',
                        },
                        '& .MuiDataGrid-columnSeparator': {
                            visibility: 'hidden',
                        },
                        '& .MuiDataGrid-columnHeader:focus-within, & .MuiDataGrid-cell:focus-within': {
                            outline: 'none',
                        },
                        '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-cell:focus': {
                            outline: 'none',
                        },
                        '& .bravasDashed': {
                            cursor: 'pointer',
                            backgroundColor: 'secondary.dark',
                            color: 'text.secondary',
                            '&:nth-of-type(2n)': { backgroundColor: 'secondary.main' },
                            '&.Mui-selected': {
                                backgroundColor: 'primary.light',
                            },
                            borderColor: '#62AC6A',
                            borderStyle: 'dashed',
                            borderWidth: '0.2px',
                            borderRadius: '10px',
                            my: '1px',
                        },
                        '& .bravasNormal': {
                            cursor: 'pointer',
                            backgroundColor: 'secondary.dark',
                            color: 'text.secondary',
                            '&:nth-of-type(2n)': { backgroundColor: 'secondary.main' },
                            '&.Mui-selected': {
                                backgroundColor: 'primary.light',
                            },
                        },
                    } }) })), (0, jsx_runtime_1.jsx)("div", { style: {
                    height: '15px',
                    width: '100%',
                    borderRadius: '0px 0px 10px 10px',
                    boxShadow: 'inset 0px -15px 10px -15px #CCC',
                    backgroundColor: 'transparent',
                    marginTop: '-15px',
                    position: 'relative',
                    zIndex: -1,
                } })] })));
}
exports.default = BravasTable;
BravasTable.defaultProps = {
    handleRowSelection: function () { },
    height: '638px',
    searchBarAdvancedSettings: true,
    showActionButtons: true,
    searchBar: true,
    onRowClick: function () { },
    rowHeight: 45,
    dashedIds: [],
    handleSelectedRows: undefined,
    idField: 'id',
    hideCheckBox: false,
    isRowSelectable: undefined,
    hideList: {},
    exportTool: true,
    defaultSortingField: undefined,
};
//# sourceMappingURL=BravasTable.js.map